var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"link-list",class:{ unstyle : _vm.unstyle }},_vm._l((_vm.links),function(link,i){return _c('li',{key:i + link.url},[_c('Link',{attrs:{"link":link}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }